import { isAbsoluteUrl } from './isAbsoluteUrl';

export enum LinkType {
  absolute = 'absolute',
  relative = 'relative',
  mailto = 'mailto',
  document = 'document',
}

export const getLinkType = (href: string) => {
  if (href.startsWith('mailto:')) {
    return LinkType.mailto;
  }

  if (isAbsoluteUrl(href)) {
    return LinkType.absolute;
  }

  if (href.endsWith('.pdf')) {
    return LinkType.document;
  }

  return LinkType.relative;
};
